(function (global){
'use strict';

var angular = (typeof window !== "undefined" ? window['angular'] : typeof global !== "undefined" ? global['angular'] : null);

/**
 * @ngInject
 */
function TooltipPopupDirective(getUID){
  // Runs during compile
  return {
    link: function($scope, iElm) {
      //Add role tooltip
      iElm.attr('role', 'tooltip');
      //Add a Unique ID
      var idtooltip = getUID('tooltip-');
      iElm.attr('id', idtooltip);
      var originElement = angular.element(iElm[0].previousElementSibling);
      originElement.attr('aria-describedby', idtooltip);

      //Remove tooltip on keyup ESC
      function dismissTooltip (e) {
        if(e.keyCode === 27){
          iElm.remove();
        }
      }
      originElement.bind('keyup', dismissTooltip);

      $scope.$on('$destroy',function() {
        originElement.removeAttr('aria-describedby');
        originElement.unbind('keyup', dismissTooltip);
      });

    }
  };
}
TooltipPopupDirective.$inject = ["getUID"];

module.exports = TooltipPopupDirective;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9BcHBCdW5kbGUvUmVzb3VyY2VzL3NjcmlwdHMvYXBwL21vZHVsZXMvdmlldy9kaXJlY3RpdmUvdG9vbHRpcFBvcHVwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EiLCJmaWxlIjoiZ2VuZXJhdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXNDb250ZW50IjpbIid1c2Ugc3RyaWN0JztcblxudmFyIGFuZ3VsYXIgPSAodHlwZW9mIHdpbmRvdyAhPT0gXCJ1bmRlZmluZWRcIiA/IHdpbmRvd1snYW5ndWxhciddIDogdHlwZW9mIGdsb2JhbCAhPT0gXCJ1bmRlZmluZWRcIiA/IGdsb2JhbFsnYW5ndWxhciddIDogbnVsbCk7XG5cbi8qKlxuICogQG5nSW5qZWN0XG4gKi9cbmZ1bmN0aW9uIFRvb2x0aXBQb3B1cERpcmVjdGl2ZShnZXRVSUQpe1xuICAvLyBSdW5zIGR1cmluZyBjb21waWxlXG4gIHJldHVybiB7XG4gICAgbGluazogZnVuY3Rpb24oJHNjb3BlLCBpRWxtKSB7XG4gICAgICAvL0FkZCByb2xlIHRvb2x0aXBcbiAgICAgIGlFbG0uYXR0cigncm9sZScsICd0b29sdGlwJyk7XG4gICAgICAvL0FkZCBhIFVuaXF1ZSBJRFxuICAgICAgdmFyIGlkdG9vbHRpcCA9IGdldFVJRCgndG9vbHRpcC0nKTtcbiAgICAgIGlFbG0uYXR0cignaWQnLCBpZHRvb2x0aXApO1xuICAgICAgdmFyIG9yaWdpbkVsZW1lbnQgPSBhbmd1bGFyLmVsZW1lbnQoaUVsbVswXS5wcmV2aW91c0VsZW1lbnRTaWJsaW5nKTtcbiAgICAgIG9yaWdpbkVsZW1lbnQuYXR0cignYXJpYS1kZXNjcmliZWRieScsIGlkdG9vbHRpcCk7XG5cbiAgICAgIC8vUmVtb3ZlIHRvb2x0aXAgb24ga2V5dXAgRVNDXG4gICAgICBmdW5jdGlvbiBkaXNtaXNzVG9vbHRpcCAoZSkge1xuICAgICAgICBpZihlLmtleUNvZGUgPT09IDI3KXtcbiAgICAgICAgICBpRWxtLnJlbW92ZSgpO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgICBvcmlnaW5FbGVtZW50LmJpbmQoJ2tleXVwJywgZGlzbWlzc1Rvb2x0aXApO1xuXG4gICAgICAkc2NvcGUuJG9uKCckZGVzdHJveScsZnVuY3Rpb24oKSB7XG4gICAgICAgIG9yaWdpbkVsZW1lbnQucmVtb3ZlQXR0cignYXJpYS1kZXNjcmliZWRieScpO1xuICAgICAgICBvcmlnaW5FbGVtZW50LnVuYmluZCgna2V5dXAnLCBkaXNtaXNzVG9vbHRpcCk7XG4gICAgICB9KTtcblxuICAgIH1cbiAgfTtcbn1cblRvb2x0aXBQb3B1cERpcmVjdGl2ZS4kaW5qZWN0ID0gW1wiZ2V0VUlEXCJdO1xuXG5tb2R1bGUuZXhwb3J0cyA9IFRvb2x0aXBQb3B1cERpcmVjdGl2ZTtcbiJdfQ==